import { Paths } from './paths.constants';

export const LandingPages = {
    Start: Paths.Start,
    Orders: Paths.Orders,
    Reports: Paths.Reports,
    Shop: Paths.Shop,
    PatientsSearch: Paths.PatientsSearch,
    OrderCreation: Paths.OrderCreation,
    ViewDocuments: Paths.Documents,
} as const;
